import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom"; 
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify"; 
import "./style.css"; 

import Login from "./Auth/Login";
import OtpVerification from "./Auth/OtpVerification";
import ForgotPassword from "./Auth/ForgotPassword";
import Registration from "./Auth/Registration";
import Logout from "./Auth/Logout";
import Profile from "./Sms/profile";
import LandingPage from "./Sms/landing";
import MusicManager from "./Sms/musicmanager";
import CategoryManager from "./Sms/categorymanager";
import AdminPage from "./Sms/adminpage";


import DashboardLayout from "./components/DashboardLayout";
import DeveloperDocsPage from "./components/DeveloperDocsPage";
import MessagingPage from "./components/MessagingPage";
import OverviewPage from "./components/OverviewPage";
import SecurityPage from "./components/SecurityPage";
import VidEnvironsnew from "./components/VidEnvironsnew";
import ContactsPage from "./components/ContactsPage";
export const StandardURL = "https://api.multiphasicinfraconstruct.co.ke/sms";



function App() {
  return (
    <Router>
      <Routes>
        {/* ── Public Routes ─────────────────────────────────────────── */}
        <Route path="/" element={<Login />} />
        <Route path="/OtpVerification" element={<OtpVerification />} />
        <Route path="/Registration" element={<Registration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/logout" element={<Logout />} />

        {/* ── Authenticated Routes (Any logged-in user) ─────────────── */}
        <Route 
          path="/sms/start" 
          element={
            <TokenGuard>
              <AuthGuard>
                <LandingPage />
              </AuthGuard>
            </TokenGuard>
          } 
        />

        <Route 
          path="/sms/dashboardlayout" 
          element={
            <TokenGuard>
              <AuthGuard>
                <DashboardLayout />
              </AuthGuard>
            </TokenGuard>
          } 
        />

        <Route 
          path="/sms/developerdocs" 
          element={
            <TokenGuard>
              <AuthGuard>
                <DeveloperDocsPage />
              </AuthGuard>
            </TokenGuard>
          } 
        />

         <Route 
          path="/sms/messaging" 
          element={
            <TokenGuard>
              <AuthGuard>
                <MessagingPage />
              </AuthGuard>
            </TokenGuard>
          } 
        />

        <Route 
          path="/sms/contacts" 
          element={
            <TokenGuard>
              <AuthGuard>
                <ContactsPage />
              </AuthGuard>
            </TokenGuard>
          } 
        />

         <Route 
          path="/sms/overview" 
          element={
            <TokenGuard>
              <AuthGuard>
                <OverviewPage />
              </AuthGuard>
            </TokenGuard>
          } 
        />

        <Route 
          path="/sms/security" 
          element={
            <TokenGuard>
              <AuthGuard>
                <SecurityPage />
              </AuthGuard>
            </TokenGuard>
          } 
        />

        <Route 
          path="/sms/videnrivonsnew" 
          element={
            <TokenGuard>
              <AuthGuard>
                <VidEnvironsnew />
              </AuthGuard>
            </TokenGuard>
          } 
        />


        <Route 
          path="/caretaker/profile" 
          element={
            <TokenGuard>
              <AuthGuard>
                <Profile />
              </AuthGuard>
            </TokenGuard>
          } 
        />

        <Route 
  path="/sms/admin" 
  element={
    <AdminGuard>
      <AdminPage />
    </AdminGuard>
  } 
/>

        {/* ── Admin Only Routes ─────────────────────────────────────── */}
        <Route 
          path="/sms/musicmanager" 
          element={
            <AdminGuard>
              <MusicManager />
            </AdminGuard>
          } 
        />
        <Route 
          path="/sms/categorymanager" 
          element={
            <AdminGuard>
              <CategoryManager />
            </AdminGuard>
          } 
        />

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ToastContainer />
    </Router>
  );
}

export default App;


// ─── Guards ─────────────────────────────────────────────────────────────

export function AuthGuard({ children }) {
  const navigate = useNavigate();
  useEffect(() => {
    const userDataString = localStorage.getItem("user");
    try {
      const userData = JSON.parse(userDataString);
      const userId = userData?.unique;
      if (!userId) {
        navigate("/");
      }
    } catch (error) {
      navigate("/");
    }
  }, [navigate]);

  return <>{children}</>;
}

export function TokenGuard({ children }) {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  return <>{children}</>;
}

// NEW: Admin Guard strictly for 'ADMIN' role
export function AdminGuard({ children }) {
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    const userDataString = localStorage.getItem("user");

    // 1. If not logged in at all, kick to login
    if (!token || !userDataString) {
      navigate("/");
      return;
    }

    try {
      const userData = JSON.parse(userDataString);
      
      // 2. Check if the user is an Admin
      // Make sure the property matches exactly what your backend sends (e.g., 'role', 'Role')
      if (userData?.role !== "ADMIN") {
        // Kick non-admins back to the landing page
        navigate("/sms/start");
      }
    } catch (error) {
      console.error("AdminGuard Error:", error);
      navigate("/");
    }
  }, [navigate]);

  return <>{children}</>;
}